import { ReactNode } from 'react'
import { StoryblokImage } from '@cinch-nx/data-storyblok'
import { StarRating } from '../star-rating'
import { AuthorByline } from '@cinch-nx/landing-ui-shared'
import styles from './intro.module.css'
import sharedStyles from '../../car-reviews-v2.module.css'

export interface IntroProps {
  contentTitle: string
  contentStarRating: number
  contentIntroText: ReactNode
  authorImage: StoryblokImage
  authorName: string
  latestPublishDate: string
}

export const Intro = ({
  contentTitle,
  contentStarRating,
  contentIntroText,
  authorImage,
  authorName,
  latestPublishDate,
}: IntroProps) => (
  <>
    <h1 className={styles.heading}>{contentTitle}</h1>

    <StarRating starRating={Number(contentStarRating)} />

    <div className={sharedStyles.reviewCopy}>{contentIntroText}</div>

    <AuthorByline
      name={authorName}
      image={authorImage}
      latestPublishDate={latestPublishDate}
    />
  </>
)
